<template>
  <view-edit-panel
    v-if="showPanel"
    class="registration-data"
    :disable-save="!canSave"
    v-model="assetInfo"
    @changing="save"
  >
  <template
    slot-scope="data"
  >
    <data-form
      v-model="data.item"
      :editing="data.editing"
      :saving="data.saving"
      @validate="onValidate"
    />
  </template>
  </view-edit-panel>
  <s-empty-list
    v-else
    :loading="loading"
  />
</template>
<script>
import GeneralDataService from '@/domain/services/installation/assetInfo/generalData';
import loadingMixin from '@/services/loadingMixin';
import ViewEditPanel from '@/components/ViewEditPanel';
import DataForm from '@/domain/components/installation/assetInformation/disconnectors/Form';
import TreeviewHeaderSubtitleMixin from '@/components/treeview/treeviewHeaderSubtitleMixin';

export default {
  props: {
    asset: Object,
  },
  components: {
    ViewEditPanel,
    DataForm,
  },
  mixins: [
    loadingMixin,
    TreeviewHeaderSubtitleMixin,
  ],
  data: () => ({
    assetInfo: null,
    isValid: true,
  }),
  computed: {
    canSave() {
      return this.isValid;
    },
    showPanel() {
      return !this.loading && this.assetInfo;
    },
  },
  created() {
    this.loadAssetInfo();
    this.updateHeaderTitle(this.$t('asset-information.asset-info.disconnector.general-data'));
  },
  methods: {
    async loadAssetInfo() {
      this.startLoading();
      try {
        this.assetInfo = await GeneralDataService.getGeneralDisconnectorData(this.asset.id) || {};
      } finally {
        this.endLoading();
      }
    },
    save({ newValue, accept, reject }) {
      GeneralDataService.updateGeneralDisconnectorData(newValue, this.asset.id)
        .then(accept)
        .catch(reject);
    },
    onValidate(isValid) {
      this.isValid = isValid;
    },
  },
};
</script>
